import React, { useEffect, useState } from 'react'
import HomeLayout from '../../../Layout/HomeLayout';
import DynamicHomeCard from '../../../CustomComponents/DynamicHomeCard';
import HomeHeader from '../../../CustomComponents/HomeHeader';
import { GetApiHeadersWithBearer, GetRequest } from '../../../../network/NetworkUtils';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AccountDetailsHeder, copyToClipboard, MoreServices, QuickActions, SPENDING,addLineBreaks } from '../../../../utils';
import { CHECKING, SAVINGS, GET_DDA_DETAILS, GET_DDA_DOWNLOAD_URL, STATUS_SUCCESS_CODE, PAID_PROMO_KEY } from '../../../../network/URLConstants';
import { appTheme, retrieveData, showKudzuPlusPrompt } from '../../../../helpers/utils/Utils';
import { width } from '../../../CustomComponents/DynamicHomeCard/DynamicHomeCardStyles';
import DynamicCard from '../../../CustomComponents/DynamicHomeCard';
import DynamicCardSavings from "../../../CustomComponents/DynamicCard";
import FooterContent from '../../../CustomComponents/Footer';
import ClimbImg from '../../../../assets/images/illo-climb.png';
import beneficiarysaving from '../../../../assets/images/beneficiarysaving.png';
import LineBreaks from '../../../../utils';
import CustomAlertModel from '../../../CustomComponents/CustomAlertModel';
import LearnMore_downArrow from '../../../../assets/kudzu-plus-images/LearnMore_downArrow.png';
import { useLocation, useNavigate } from 'react-router-dom';
import logFirebaseEvents from '../../../LogFirebaseEvents';
import kudzuPlusLogo from "../../../../assets/kudzu-plus-images/kudzu-plus-white-logo.png";
import CustomModalPlus from "../../../../kudzu_plus/helpers/customModalPlus";
import MemnershipEnrollmentScreens from '../../../../kudzu_plus/components/membershipEnrollmentScreens';
import CardHeading from '../../../CustomComponents/CardHeading';
import BenificiaryPlus from "../../../../assets/kudzu-plus-images/Benificiary.png"
import Cookies from 'js-cookie';
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle';
 

const AccountServicesCheckingCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
    // Set document title based on current path
    const currentPath = window.location.pathname;
    const documentTitle =
        currentPath.toLowerCase().includes('spending')
            ? t('page_title_spending_account_services')
            : t('page_title_checking_account_services');
    useDocumentTitle(documentTitle);


  const [checkingAccountNumber, setCheckingAccountNumber] = useState('*********'); //Account Number
  const [checkingRoutingNumber, setCheckingRoutingNumber] = useState('*********');
  const [savingAccountNumber, setSavingAccountNumber] = useState('*********'); //Account Number
  const [savingRoutingNumber, setSavingRoutingNumber] = useState('*********');
  const cards = useSelector(state => JSON.parse(state.userCards));
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const accessTokenToApi = useSelector(state => state.accessToken);
  const [accountCopied, setAccountCopied] = useState(false);
  const [routingCopied, setRoutingCopied] = useState(false);
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch();

  const HighlightMsgStyles = "sm:w-auto w-[253px] font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[#2965FB] cursor-pointer pointer-events-none";
  const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
  const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
  const [highlightMsg, setHighlightMsg] = useState('')
  const [headerMsg, setheaderMsg] = useState('')
  const [subHeaderMsg, setSubHeaderMsg] = useState('')
  const [btn1Exists, setBtn1Exists] = useState(false)
  const [btn2Exists, setBtn2Exists] = useState(false)
  const [btn1Text, setBtn1Text] = useState(false)
  const [btn2Text, setBtn2Text] = useState('')
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
  const [footerMsg, setFooterMsg] = useState('');
  const [showModel, setShowModel] = useState(false);
  const [modelImage, setModelImage] = useState('')
  const savingsCardAvailable = useSelector(state => state.savingsAccontAvailable);
  const [savingsTheme, setSavingsTheme] = useState(false);
  const [isBorderNone, setisBorderNone] = useState(true);
  const [isShowKudzuPlusLearnMore,setIsShowKudzuPlusLearnMore] = useState(false);
  const [showPlusModal, setShowPlusModal] = useState(false);
  const [carousel, setCarousel] = useState('');
  const [btn1BgColor, setBtn1BgColor] = useState("");
  const [summaryParagraph, setSummaryParagraph] = useState('');
  const [opacityValueLow, setOpacityValueLow] = useState(false);
  const [comparisonScreen, setComparisonScreen] = useState('');
  const [fullWidth, setFullWidth] = useState(false);
  const [footerButtonEnable, setFooterButtonEnable] = useState(false);
  const [gradientButton, setGradientButton] = useState(false);
  const [largeImage, setLargeImage] = useState(false);
  const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);
  const [isMembershipDismissed, setIsMembershipDismissed] = useState(false);


  const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[13px] md:text-[10px] sm:text-[6px] text-[8px] font-[200] cursor-pointer pointer-events-none";
  const HeaderMsgStylesForPlus = "font-serif-pro modal-title text-white lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-[400] cursor-pointer pointer-events-none";

  const isShowKudzuPlusPrompt = showKudzuPlusPrompt(loggedResponse);
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 

  const appThemeData = appTheme(kudzuPlusTrue)
  const [promoKey,setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
  const isSmiOneIsTrue = useSelector(state => state.smiOneAccountTrue);

  const currentpath = useLocation()

  useEffect(() => {
    dispatch({ type: 'SELECTED_SUB_INDEX', payload: { selectedSubIndex: -1 } });
    cards?.map((item) => {
      if (item.AccountTypeBit63 === 64) {
        const { AccountTypeName, CardKey } = item;
        getAccountNumberDetails(AccountTypeName, CardKey);
      }
      return null; // Return null from the map to avoid returning a new array
    });
  }, []);


  ///more services

  const moreServicesArray = [
    { name: 'Edit Account Name', actionType: '', path: '/AccountServices/Spending/EditAccountName' }
  ];
  useEffect(() => {
    if (cards != null && cards?.length > 0 && cards?.[0]?.AllowAuthorizedUsers) {
      moreServicesArray.push({ name: t('menu_manage_authorized_users'), actionType: "", path: '/AccountServices/Spending/ManageAuthorizedUsers' })
    }
  }, [cards])


  const getAccountNumberDetails = async (cardType, cardkey) => {
    // debugger;
    if (cardkey == undefined || cardkey == null) {
      return
    }
    setLoading(true)
    let url = GET_DDA_DETAILS + cardkey;
    const deviceId = await retrieveData('updatedDeviceId');
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    var response = await GetRequest(url, headers)
    setTimeout(() => {
      setLoading(false)
    }, 500);
    var responseObj = JSON.parse(response);
    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
      if (responseObj.Response != undefined) {
        if (cardType == CHECKING || SPENDING) {
          setCheckingAccountNumber(responseObj.Response.ExternalSVAID != undefined ? responseObj.Response.ExternalSVAID : '--');
          setCheckingRoutingNumber(responseObj.Response.RoutingNumber != undefined ? responseObj.Response.RoutingNumber : '--')
        } else {
          setSavingAccountNumber(responseObj.Response.ExternalSVAID != undefined ? responseObj.Response.ExternalSVAID : '--');
          setSavingRoutingNumber(responseObj.Response.RoutingNumber != undefined ? responseObj.Response.RoutingNumber : '--')
        }

      }
    } else {
      var arrMessages = responseObj.Messages;
      var message = arrMessages[0];
      var displayText = message.DisplayText;
    }
  }


  const accountNumberCopiedClicked = () => {
    logFirebaseEvents("Account_services", "account_number_copied", "account_number_copied", "", "");
    copyToClipboard(checkingAccountNumber, setAccountCopied(true))
    setAccountCopied(true);
    setTimeout(() => {
      setAccountCopied(false);
    }, 2000);

  }
  const routingNumberCopiedClicked = () => {
    logFirebaseEvents("Account_services", "routing_number_copied", "routing_number_copied", "", "");
    copyToClipboard(checkingRoutingNumber, setRoutingCopied(true))
    setRoutingCopied(true);
    setTimeout(() => {
      setRoutingCopied(false);
    }, 2000);
  }
  
  useEffect(() => {
    const MembershipDismisseGet = `MembershipDismissed${cards[0].CardKey}`;
    const MembershipShown = Cookies.get(MembershipDismisseGet);
    setIsMembershipDismissed(MembershipShown);  
}, []);


const handleDismiss = () => {
  const MembershipDismisse = `MembershipDismissed${cards[0].CardKey}`;
  Cookies.set(MembershipDismisse, 'true', { expires: 1825 });
  setIsMembershipDismissed(true);
}; 

  ///Quick Actions

  const QuickActionsButtons = [
    { name: `${t('add_fund')}`, actionType: "", path: '/AccountServices/Spending/AddFunds' },
    { name: "Transfer Money", actionType: "", path: '/AccountServices/Spending/TransferMoney' },
  ]

  //footer
  const footerContent = () => {
    return (
      < FooterContent
        highlightText={isSmiOneIsTrue ? t("climb_heading_new") : t('Financial_growth_starts')}
        type={t("climb_heading_new")}
        subHeaderText={isSmiOneIsTrue ? t("climb_subHeading_new") : t('Your_toolkit_helps_you')}
        btnBgColor={kudzuPlusTrue ? "borderGradient" : "#2965FB"} image={appThemeData.CardServicesFooter}
        buttonEnabled={true} buttonText={t("climb_btn")} footerBtnAction={() => {
          const currentPath = { currentPathFromStore: currentpath.pathname };
                        dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
          //  navigate('/Climb');
          navigate("/Toolkit/ToolkitMenu",{ state: { isClimbShowPopups:true } });
           }} borderDirection={cards?.[0]?.AllowPayPerks ? (cards?.length % 2 == 0) ? 'odd' : 'even' : (cards?.length % 2 == 0) ? 'even' : 'odd'} />
    )

  }

  const enrollSavingsAccount = () => {
    const savingsNewPayload = { savingsNewClicked: true };
    dispatch({ type: 'SAVINSGS_DISABLED', payload: savingsNewPayload });
    if (kudzuPlusTrue) {
      showAlertModalPlus(true, "",
        promoKey == PAID_PROMO_KEY ? t("Get_1.25%_APY_on_an_optional_savings_account_with_trial") : t('Get_1.25%_APY_on_an_optional_savings_account'),
        "", true, true, t("enroll"), t("may_be_later"), true, require('../../../../assets/kudzu-plus-images/Benificiary.png'), "", true, "#262B3A",
        '',
        true, '', false, false, true, true);
    }
    else {
      showAlertModal(true, '', t('set_aside_money_for_the_things_that_matter'), t('add_savings_account_subTitle'), true, true, t('enroll'), t('may_be_later'), true, beneficiarysaving, true, true);
    }
  }

  const enrollSavingsFooterContent = () => {
    return (
      kudzuPlusTrue ?
        <DynamicCardSavings
          footer={true}
          header={false}
          CardRadius={false}
          cardWidth={width.homeCard}
          HeaderRadius={false}
          isWhite={appThemeData.isWhiteBgForCard}
          isDarkForKudzu={appThemeData.isDarkBgForCard}
          backgroundColor={'--cardHeading-bg'}
          HeaderContent={
            <>
              <CardHeading heading={t('savings')} image={appThemeData.isBlueIconForSavings}
                endBtnText={t('enroll')} endBtn={true} headerButtonClick={enrollSavingsAccount} />
            </>
          }
        >

          <div className="my-20">
            <div className="flex justify-between">
              <div>
                <p className="text-white md:w-[310px]">{t('set_aside_money_for_things_that_matter')}</p>
              </div>
              <div>
                <img src={BenificiaryPlus} alt="Benificiary"  />
              </div>
            </div>
          </div>
        </DynamicCardSavings>  :

        <FooterContent
          cardHeight={'200px'}
          backgroundColor={'#D3D3D3'}
          btnBgColor={'#30BC89'}
          btnTextColor={'#FFFFFF'}
          isSubheadingwidth={true}
          highlightTextColor={'#0C4437'}
          subHeaderTextColor={'#0C4437'}
          highlightText={t("grow_urMoney_withSavings")}
          subHeaderText={LineBreaks(t("set_aside_funds_savings"))}
          image={beneficiarysaving}
          buttonEnabled={true}
          buttonText={t("enroll")} isSpace={true}
          type='AddSavings'
          footerBtnAction={() => {
             enrollSavingsAccount()
            // const savingsNewPayload = { savingsNewClicked: true };
            // dispatch({ type: 'SAVINSGS_DISABLED', payload: savingsNewPayload });
            // showAlertModal(true, '', t('set_aside_money_for_the_things_that_matter'), t('add_savings_account_subTitle'), true, true, t('enroll'), t('may_be_later'), true, beneficiarysaving, true, true);
          }}
          borderDirection={cards?.[0]?.AllowPayPerks ? (cards?.length % 2 == 0) ? 'odd' : 'even' : (cards?.length % 2 == 0) ? 'even' : 'odd'}
        />
    )
  }

  const kudzuPlusChecking = () => {
    return (
      <FooterContent highlightText={addLineBreaks(t("Early_ACH_Access_with_Kudzu+_Updated"))}
        subHeaderText={addLineBreaks(t("Get_access_to_funds_Updated"))}
        isDismisButton={true}
        isHeadingTextSize={"32px"}
        isSubHeaderTextSize={"19px"}
        subHeaderTextColor={"#ffffff"}
        content ={addLineBreaks(t("Spending_Content_Trail"))}
        image={LearnMore_downArrow} buttonEnabled={true}
        buttonText={t("learn_more")}
        buttonCancelText={t('dismiss')}
        isMainMargin={"10"}
        isMarginTop={"51%"}
        isGap={"10rem"}
        footerBtnActionCancelKudzu={handleDismiss}
        footerBtnAction={()=>{
        setShowCarouselScreensShow(false);
        //  showAlertModalPlus(true, t("thanks"), t("Try_a_Kudzu+_membership_for_three_months"), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('../../../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "#262B3A", t('first_three_months_charged_automatically'), true, '', false, false, true, true);
        showAlertModalPlus(true,
          promoKey == PAID_PROMO_KEY ? "" : t("thanks"),
          promoKey == PAID_PROMO_KEY ?  addLineBreaks(t('paid_access_exclusive_fature_and_benfits_when_you_join_kudzu_plus')) :t("Try_a_Kudzu+_membership_for_three_months"),
          "", true, true, t('Learn_More'), t('No_Thanks'), true, require('../../../../assets/kudzu-plus-images/K-plus-logo.png'), "", true, "#262B3A",
          promoKey == PAID_PROMO_KEY ?  t('monthly_memebership_fee_will_be_automatically_deducted') : t('first_three_months_charged_automatically'),
            true, '', false, false, true, true);
        }}
        type={t("kudzuPlusLearnMore")}
        borderDirection={'odd'}
        isSubheadingwidth={false}
      />)
  }

  const closeCustomAlertModal = () => {

    setShowModel(false);
  }

  const onAcptBtnClick = async () => {
    setShowModel(false)
    if (btn1Text == t("enroll")) {
      navigate('/SetupSavingsAccount')
      dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('account_services_savings_enrollment') } });
    }
    else if (btn1Text == t('home')) {
      navigate('/home')
    }
  }
  const onCancelBtnClick = () => {
    setShowModel(false)
    showAlertModal(true, '', t('savings_no_problem_title'), t('via_account_services_title'), true, false, t('okay_got_it'), '', true, beneficiarysaving, true, true);
  }
  const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, savingsTheme, isBorderNone) => {
    setShowModel(showModel)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setSavingsTheme(savingsTheme)
    setisBorderNone(isBorderNone)

  }

  const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage) => {
    setShowPlusModal(showPlusModal)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setBtn1Exists(btn1Exists)
    setBtn1Text(btn1Text)
    setCarousel(carousel)
    setisBorderNone(isBorderNone)
    setBtn1BgColor(btn1BgColor)
    setSummaryParagraph(summaryParagraph)
    setOpacityValueLow(opacityValue)
    setComparisonScreen(comparisonScreen)
    setFullWidth(fullWidth)
    setFooterButtonEnable(footerButtonEnable)
    setGradientButton(gradientButton)// gradient button for popup
    setLargeImage(largeImage)
  }

  const closeModelPlus = () => {
    setShowPlusModal(false);
    setShowCarouselScreensShow(false);
  }
  const onAcptBtnClickPlusModal = () => {
    setShowPlusModal(false)
    if (btn1Text == t("enroll")) {
      navigate('/SetupSavingsAccount')
      dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('account_services_savings_enrollment') } });
    }
    const currentPath = { currentPathFromStore: currentpath.pathname };
    dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
    setShowCarouselScreensShow((prev) => !prev);
    const data = { kudzuFlowFrom: "fromAccountSpending" };
    dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
   
  }
  const onCancelBtnClickPlusModal = () => {
    setShowPlusModal(false)
    if (btn1Text == t("enroll")) {
     showAlertModal(true, '',<p><span className='text-[var(--enroll-maybelater-hilight)]'>{t('no_problem_exclimation')}</span><span>{" "}</span>{t('You_may_add_a_Kudzu_SavingsAc_count_at_any_time')}</p>, t('via_account_services_title'), true, false, t('okay_got_it'), '', true, appThemeData.cell, true, true);
    }
  }


  return (
    <HomeLayout>
      <HomeHeader heading="" isHeaderCaption={false} />
      {showCarouselScreenShow && 
       <MemnershipEnrollmentScreens/> }
      <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight  '>

        <DynamicCard
          header={true}
          footer={false}
          CardRadius={true}
          HeaderRadius={true}
          isWhite={appThemeData.isWhiteBgForCard}
          isDarkForKudzu={appThemeData.isDarkBgForCard}
          cardWidth={width.homeCard}
          backgroundColor={'--cardHeading-bg'}
          HeaderContent={
            <>
                <CardHeading image={appThemeData.isGreenIconForSpending} heading={SPENDING} allContent={true} />
            </>
        }
        >
          {/* <div className=" lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500] 
        lg:text-[26px] md:text-[22px] 
        sm:text-[20px] text-[20px]
            leading-[36px] font-hanken-grotesk sm:mx-0 mx-4">
            {SPENDING}
          </div> */}
          <AccountDetailsHeder
            AccountNo={checkingAccountNumber}
            routingNo={checkingRoutingNumber}
            accountCopiedProps={accountCopied}
            routingCopiedProps={routingCopied}
            handleCopyClick={accountNumberCopiedClicked}
            handleCopyRoutingNumberClick={routingNumberCopiedClicked}
            contentBetween={true}
            topBorder={appThemeData.borderTopForAccServices}
            bottomBorder={true}
            isCopyblack={true}
          />

          <QuickActions actionsArray={QuickActionsButtons} />

          {/* /////more service */}
          <div className="border-t-[2.5px] border-[var(--transactions-acc-number-border)] flex flex-col justify-center sm:mx-0 mx-4">
            <MoreServices actionsArray={moreServicesArray} />
          </div>
        </DynamicCard>
        {savingsCardAvailable == false && cards !== null && cards[0]?.AllowSavings ? enrollSavingsFooterContent() : cards !== null && cards[0]?.IsClimbAllowed ? footerContent() : null}

        {(!kudzuPlusTrue && isShowKudzuPlusPrompt) ? kudzuPlusChecking()  : "" }

      </div>
      <CustomAlertModel isOpen={showModel}
        onClose={closeCustomAlertModal}
        image={modelImage}
        modalBg={'bg-[var(--text-bg-subway)]'}
        btn1BorderColor={'#30BC89'}
        btn1TextColor={'#FEFAEE'}
        btn1BrExist={ kudzuPlusTrue ? false : true}
        btn2TextColor={'#559C7E'}
        btn1BgColor={kudzuPlusTrue ? "" : '#30BC89'}
        highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
          <span className={`${HeaderMsgStyles} ${savingsTheme ? 'text-[var(--text-clr-secondary6)]'  : 'text-black'}`}> {headerMsg}</span></p>}
        // highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
        // HeaderMsg={<p className={HeaderMsgStyles}>{headerMsg}</p>}
        subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text} btn2Text={btn2Text}
        btn1TypeAcpt={btn1TypeAcpt}
        verificationFailure={() => { }}
        footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
        onAcptBtnClick={onAcptBtnClick}
        onCancelBtnClick={onCancelBtnClick}
        isBorderNone={isBorderNone}
      />

      <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
        image={modelImage}
        carousel={carousel}
        summaryParagraph={<p className={summaryParagraphStyles}>{summaryParagraph}</p>}
        isBorderNone={isBorderNone}
        highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
        subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text}
        btn1BgColor={btn1BgColor}
        btn2Text={btn2Text}
        opacityLow={opacityValueLow}
        defaultCornerRadius={false}
        btn1TypeAcpt={btn1TypeAcpt}
        onAcptBtnClick={onAcptBtnClickPlusModal}
        onCancelBtnClick={onCancelBtnClickPlusModal}
        gradientButton={gradientButton}
        largeImage={largeImage}
        btn2TextColor={'#779CE5'}

      />

    </HomeLayout>
  )
}

export default AccountServicesCheckingCard;